export default __webpack_public_path__ + "static/media/filledStar.de82f684.svg";